<div class="card-content">
  <div class="sidebar-spacer"></div>
  <div class="sidebar-section" [style.background-color]="viewModel.sidebarSectionBackgroundColor$ | push">
    <div
      *rxIf="data | sectionRowViewModelBasicMethod: 'getSidebarText' as text"
      class="sidebar-text"
      appScaleDownText
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | push"
      [style.color]="viewModel.headerTextColor$ | push">
      {{ text }}
    </div>
  </div>
  <div class="main-section" [style.color]="viewModel.bodyTextColor$ | push">
    <div class="card-top">
      <div class="title-brand-and-label-container">
        <div
          *rxIf="data | sectionRowViewModelBasicMethod: 'getRowTitle' as title"
          appPrintCardScaleDownText
          [maxHeightInPx]="45"
          [transparentWhileScaling]="viewModel.viewingInLiveView$ | push"
          class="product-card-name">
          {{ title | trimSafely }}
        </div>
        <div class="brand-and-label">
          <div
            *rxIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
            appPrintCardScaleDownText
            [maxHeightInPx]="16"
            [transparentWhileScaling]="viewModel.viewingInLiveView$ | push"
            class="product-card-brand">
            {{ brand | trimSafely }}
          </div>
          <app-label-inflator
            class="print-card-label"
            [columnLabel]="false"
            [labelComponentInterface]="data"
            [reset]="false">
          </app-label-inflator>
        </div>
      </div>
      <div
        *rxIf="(data?.menu | printCardMenuBasicMethod: 'getNumberOfBadgesForVariant' : data) > 0"
        class="product-card-badge-container">
        <img
          *rxFor="let variantBadge of data | printCardBadges"
          appImage
          class="product-card-badge"
          [asset]="variantBadge?.image"
          alt="badge"
          src="" />
      </div>
    </div>

    <div class="card-bottom">
      <div class="properties-and-size-container">
        <ng-container *rxFor="let property of viewModel.propertiesBasedOnPools$ | push">
          <div class="property-container">
            <div class="title">{{ property.title }}</div>
            <div
              class="value"
              appPrintCardScaleDownText
              [maxHeightInPx]="13"
              [transparentWhileScaling]="viewModel.viewingInLiveView$ | push">
              {{ property.value }}
            </div>
          </div>
        </ng-container>
        <div
          *rxIf="viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | push) : true : false | push as size"
          class="property-container">
          <div class="title">SIZE</div>
          <div
            class="value"
            appPrintCardScaleDownText
            [maxHeightInPx]="13"
            [transparentWhileScaling]="viewModel.viewingInLiveView$ | push">
            {{ size }}
          </div>
        </div>
      </div>
      <app-glass-house-price></app-glass-house-price>
    </div>
  </div>
</div>
